module.exports = __webpack_public_path__ + "static/media/fondo.ca569277.jpg";